import React from 'react';
import { useParams,useNavigate } from "react-router-dom";
import ListVpsUsByStatusPage from "../ListVpsUsByStatusPage";

const AdminListVpsUsByStatusPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectChangeUser = (listVpsId) => {
        navigate('/admin/vps-us/chuyen-khach-hang.html?' + listVpsId);
    }

    let redirectExportExcel = (listVps) => {
        navigate('/admin/vps-us/xuat-file-excel.html?' + listVps);
    }

    return <ListVpsUsByStatusPage
        statusParams={ params.status }
        redirectChangeUser={ (listVpsId) => redirectChangeUser(listVpsId) }
        redirectExportExcel={ (listVps) => redirectExportExcel(listVps) }
    />

}

export default AdminListVpsUsByStatusPage;